import WordSpan from './word-span';
import { Line } from './line';
import { spaceWidth } from './space-width';

/**
 * @param {CanvasRenderingContext2D} context
 * @param {import('./span').Span[]} spans
 * @param {number[]} linesWidths
 * @param {number} indent
 */
export function breakParagraphIntoLines (context, spans, linesWidths, indent) {
  /** @type {Line[]} */
  let lines = [];
  let line = new Line([]);
  let lineI = 0;
  spans.flatMap(getWordSpans).forEach(wordSpan => {
    const isSpace = line.hasRightSpace || wordSpan.hasLeftSpace
    const spaceW = isSpace ? spaceWidth(context) : 0
    const maxWidth = linesWidths[lineI]
    if (line.width(context) + wordSpan.width(context) + spaceW + indent <= maxWidth) {
      line.append(wordSpan)
    } else {
      if (line.wordSpans.length !== 0) {
        lines.push(line);
        lineI++;
      }
      line = new Line([wordSpan]);
    }
  })
  lines.push(line);
  return lines;
}

/**
 * @param {import('./span').Span} parentSpan 
 */
function getWordSpans (parentSpan) {
  const words = parentSpan.text.trim().split(' ');
  let wordSpans = words.map((word, i) => {
    let leftSpace = true
    let rightSpace = true
    if (i === 0) {
      leftSpace = parentSpan.text.startsWith(' ')
    }
    const isLast = i === words.length - 1
    if (isLast) {
      rightSpace = parentSpan.text.endsWith(' ')
    }
    return new WordSpan(parentSpan, word, leftSpace, rightSpace)
  })
  return wordSpans
}